;(function ($) {

  var slideBox = $('.uk-testimonials-slider');
  slideBox.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

})(jQuery);